import { render, staticRenderFns } from "./RiderStory.vue?vue&type=template&id=51c521d1&scoped=true"
import script from "./RiderStory.vue?vue&type=script&lang=js"
export * from "./RiderStory.vue?vue&type=script&lang=js"
import style0 from "./RiderStory.vue?vue&type=style&index=0&id=51c521d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c521d1",
  null
  
)

export default component.exports